import Immutable from 'immutable';

export enum DmsProviderKind {
  NONE = 'NONE',
  SHAREPOINT = 'SHAREPOINT',
  ONEDRIVE = 'ONEDRIVE',
  BOX = 'BOX',
  DROPBOX = 'DROPBOX',
  GOOGLEDRIVE = 'GOOGLEDRIVE',
  EGNYTE = 'EGNYTE',
  STUDIO = 'STUDIO',
  STORAGE = 'STORAGE',
}

export interface FailedDocument {
  documentid: string;
  errorCode: string;
  errorStage: string;
}

export interface RawProcessingStatus {
  uploadTimestamp: number;
  uploadedBy: string;
  pagesProcessed: number;
  pagesCount: number;
  status: string;
  reviewedtimestamp: number;
  reviewedBy: string;
  processingRequestid: string;
  dmsProviderKind: string;
  failedDocuments: FailedDocument[];
}

export interface ProcessingStatusData {
  uploadTimestamp: number;
  uploadedBy: string;
  pagesProcessed: number;
  pagesCount: number;
  status: string;
  reviewedtimestamp: number;
  reviewedBy: string;
  processingRequestid: string;
  dmsProviderKind: DmsProviderKind;
  failedDocuments: FailedDocument[];
}

const defaultValues: ProcessingStatusData = {
  uploadTimestamp: 0,
  uploadedBy: '',
  pagesProcessed: 0,
  pagesCount: 0,
  status: '',
  reviewedtimestamp: 0,
  reviewedBy: '',
  processingRequestid: '',
  dmsProviderKind: DmsProviderKind.NONE,
  failedDocuments: new Array<FailedDocument>(),
};

export const ProcessingStatusFactory = Immutable.Record(
  defaultValues,
  'ProcessingStatus'
);

export class ProcessingStatus extends ProcessingStatusFactory {
  static deserialize(rawPS: RawProcessingStatus): ProcessingStatus {
    const type: DmsProviderKind =
      DmsProviderKind[rawPS.dmsProviderKind as keyof typeof DmsProviderKind];

    return new ProcessingStatus({
      ...rawPS,
      dmsProviderKind: type,
    });
  }

  serialize(): RawProcessingStatus {
    return this.toJS();
  }
}

export type ProcessingStatusMap = Immutable.OrderedMap<
  string,
  ProcessingStatus
>;

export type ProcessingStatusList = Immutable.List<ProcessingStatus>;
